module.exports = __webpack_public_path__ + "static/media/Qwilfish_gaussian2.5712bbe8.png";